<template>
  <svg :viewBox="svgViewBox" :class="svgClass">
    <path :d="svgPath" :style="svgStyle" />
  </svg>
</template>

<script>
import iconPaths from "../assets/iconPaths.json";

export default {
  name: "AppIcon",
  props: {
    iconName: String
  },
  data() {
    return {
      vBOne: "0 0 14 14",
      vBTwo: "0 0 30 30",
      vBThree: "0 0 24 24",
      vBFour: "0 0 20 20",
      size1: { "size-1": true },
      size2: { "size-2": true },
      size3: { "size-3": true },
      size4: { "size-4": true }
    };
  },
  computed: {
    svgPath() {
      return iconPaths[this.iconName].d;
    },
    svgStyle() {
      if (iconPaths[this.iconName].style !== undefined) return iconPaths[this.iconName].style;
      return "";
    },
    svgViewBox() {
      if (iconPaths[this.iconName].viewBoxOption === 1) return this.vBOne;
      if (iconPaths[this.iconName].viewBoxOption === 2) return this.vBTwo;
      if (iconPaths[this.iconName].viewBoxOption === 3) return this.vBThree;
      return this.vBFour;
    },
    svgClass() {
      if (iconPaths[this.iconName].viewBoxOption === 1) return this.size1;
      if (iconPaths[this.iconName].viewBoxOption === 2) return this.size2;
      if (iconPaths[this.iconName].viewBoxOption === 3) return this.size3;
      return this.size4;
    }
  }
};
</script>

<style scoped>
svg {
  display: block;
  user-select: none;
}

.size-1 {
  min-width: 14px;
  min-height: 14px;
  max-width: 14px;
  max-height: 14px;
}

.size-2 {
  min-width: 30px;
  min-height: 30px;
  max-width: 30px;
  max-height: 30px;
}

.size-3 {
  min-width: 24px;
  min-height: 24px;
  max-width: 24px;
  max-height: 24px;
}

.size-4 {
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;
}
</style>
